import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { ISubscriptionStatus, ISubscriptionStatusResponse } from '../../entity/interface/iSubscriptionStatus';
import { IGetSubscriptionStatusUseCase } from '../../core/usecases/UserIdentity/GetSubscriptionStatusUseCase';

export interface IUserIdentityService {
    getSubscriptionStatus(
        apiKey: string,
        username: string,
        token: string,
        identityToken: string
    ): Promise<ISubscriptionStatus>;
}

export class UserIdentityService implements IUserIdentityService {
    // Lazy getter for dependency to avoid circular dependencies
    private get getSubscriptionStatusUseCase(): IGetSubscriptionStatusUseCase {
        return container.resolve<IGetSubscriptionStatusUseCase>(DI.USECASES.IGetSubscriptionStatusUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getSubscriptionStatus(
        apiKey: string,
        username: string,
        token: string,
        identityToken: string
    ): Promise<ISubscriptionStatus> {
        const response = await this.getSubscriptionStatusUseCase.execute(apiKey, username, token, identityToken);
        return response;
    }
}
